import { render, staticRenderFns } from "./PdfTemplatesTable.vue?vue&type=template&id=3cbafc9c&scoped=true&"
import script from "./PdfTemplatesTable.vue?vue&type=script&lang=js&"
export * from "./PdfTemplatesTable.vue?vue&type=script&lang=js&"
import style0 from "./PdfTemplatesTable.vue?vue&type=style&index=0&id=3cbafc9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbafc9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
